"use client";

import Image from "next/image";
import logo from "@/assets/images/CashlessAi-Logo.png";
import LogoMark from "@/assets/images/logo.svg";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";

export function SidebarLogo() {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  if (isCollapsed) {
    return (
      <div className="group/header flex h-16 items-center justify-center border-b border-neutral-slate-200">
        <div className="relative flex h-8 w-8 items-center justify-center">
          <span className="flex items-center justify-center group-hover/header:hidden pointer-events-none">
            <LogoMark width={27} height={28} />
          </span>
          <SidebarTrigger className="absolute inset-0 h-8 w-8 opacity-0 group-hover/header:opacity-100 text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-16 items-center justify-between px-5 border-b border-neutral-slate-200">
      <Image
        src={logo}
        alt="Cashless AI"
        width={164}
        height={28}
        priority
        className="object-contain"
      />
      <SidebarTrigger className="text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700" />
    </div>
  );
}
